import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPorkManureAdditive, setFootprintingPorkManureAdditiveAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_MANURE_ADDITIVE } from "consts";

import { FootprintingPorkManureAdditivePayload } from "models";

export const useMutateFootprintingPorkManureAdditive = (
  farmId: string,
  year: number,
  payload: FootprintingPorkManureAdditivePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PORK_MANURE_ADDITIVE, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingPorkManureAdditiveAdmin(payload, primaryDataId) : setFootprintingPorkManureAdditive(payload, primaryDataId)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PORK_MANURE_ADDITIVE, primaryDataId, isAdmin],
          ...footprintingPorkPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
